import axios from "axios";
const state = {
  asideTab: 1,
  tree_search: null,
  pageType: null,
  titleType: null,
  loadingTree: "empty",
  categoryForceOpen: false,
  loadingFavorites: "empty",
  loadingSpecialty: "empty",
  loadingNews: "empty",
  favorites: [],
  loadingHistory: "empty",
  history: [],
  loadingHistoryPersonalCabinet: "empty",
  historyPersonalCabinet: [],
  specialty: [],
  userSpecialty: [],
  news: [],
  guidesArticle: [],
  guidesArticleLoading: "empty",
  newsHasMore: false,
  itIsAllHistory: false,
  historyOffset: 0,
  historyPersonalCabinetChunkFull: true,
  loadingContentSectionCalculatorsPosts: "empty",
  loadingContentSectionNormativePosts: "empty",
  loadingContentSectionAdditionalPosts: "empty",
  contentSectionCalculatorsPostsOffset: 0,
  contentSectionNormativePostsOffset: 0,
  contentSectionAdditionalPostsOffset: 0,
  contentSectionCalculatorsPosts: [],
  contentSectionCalculatorsPostsFavorite: [],
  contentSectionCalculatorsPostsChunkFull: true,
  itIsAllContentSectionCalculatorsPosts: false,
  contentSectionNormativePosts: [],
  contentSectionNormativePostsFavorites: [],
  contentSectionNormativePostsChunkFull: true,
  itIsAllContentSectionNormativePosts: false,
  contentSectionAdditionalPosts: [],
  contentSectionAdditionalPostsChunkFull: true,
  itIsAllContentSectionAdditionalPosts: false,
  personalCabinetMenuLabels: [],
  newsPostCount: 0,
  calculatorsPostCount: 0,
  normativePostCount: 0,
  additionalPostCount: 0,
};

const getters = {
  getAsideTab: (state) => {
    return state.asideTab;
  },
  getCategoryOpen: (state) => {
    return state.categoryForceOpen;
  },
  getPageType: (state) => {
    return state.pageType;
  },
  getTitleType: (state) => {
    return state.titleType;
  },
  getActiveLoadStatus: (state) => {
    return state.loadingTree;
  },
  getActiveTree: (state) => {
    return state.pageType ? state["tree_" + state.pageType] : [];
  },
  getFavoritesArray: (state) => {
    return state.favorites;
  },
  getFavoritesLoading: (state) => {
    return state.loadingFavorites;
  },
  getHistoryArray: (state) => {
    return state.history;
  },
  getContentSectionCalculatorsPostsArray: (state) => {
    return state.contentSectionCalculatorsPosts;
  },
  getContentSectionCalculatorsPostsFavoriteArray: (state) => {
    return state.contentSectionCalculatorsPostsFavorite;
  },
  getContentSectionNormativePostsArray: (state) => {
    return state.contentSectionNormativePosts;
  },
  getContentSectionNormativePostsFavoritesArray: (state) => {
    return state.contentSectionNormativePostsFavorites;
  },
  getContentSectionAdditionalPostsArray: (state) => {
    return state.contentSectionAdditionalPosts;
  },
  getHistoryArrayPersonalCabinet: (state) => {
    return state.historyPersonalCabinet;
  },
  getHistoryLoading: (state) => {
    return state.loadingHistory;
  },
  getLoadingContentSectionCalculatorsPosts: (state) => {
    return state.loadingContentSectionCalculatorsPosts;
  },
  getLoadingContentSectionNormativePosts: (state) => {
    return state.loadingContentSectionNormativePosts;
  },
  getLoadingContentSectionAdditionalPosts: (state) => {
    return state.loadingContentSectionAdditionalPosts;
  },
  getHistoryLoadingPersonalCabinet: (state) => {
    return state.loadingHistoryPersonalCabinet;
  },
  getSpecialtyLoading: (state) => {
    return state.loadingSpecialty;
  },
  getSpecialtyArray: (state) => {
    return state.specialty;
  },
  getUserSpecialtyArray: (state) => {
    return state.userSpecialty;
  },
  getNewsLoading: (state) => {
    return state.loadingNews;
  },
  getNewsArray: (state) => {
    return state.news;
  },
  getNewsHasMore: (state) => {
    return state.newsHasMore;
  },
  getItIsAllHistory: (state) => {
    return state.itIsAllHistory;
  },
  getHistoryPersonalCabinetChunkFull: (state) => {
    return state.historyPersonalCabinetChunkFull;
  },
  getItIsAllContentSectionCalculatorsPosts: (state) => {
    return state.itIsAllContentSectionCalculatorsPosts;
  },
  getContentSectionCalculatorsPostsChunkFull: (state) => {
    return state.contentSectionCalculatorsPostsChunkFull;
  },
  getItIsAllContentSectionNormativePosts: (state) => {
    return state.itIsAllContentSectionNormativePosts;
  },
  getContentSectionNormativePostsChunkFull: (state) => {
    return state.contentSectionNormativePostsChunkFull;
  },
  getItIsAllContentSectionAdditionalPosts: (state) => {
    return state.itIsAllContentSectionAdditionalPosts;
  },
  getContentSectionAdditionalPostsChunkFull: (state) => {
    return state.contentSectionAdditionalPostsChunkFull;
  },
  getPersonalCabinetMenuLabels: (state) => {
    return state.personalCabinetMenuLabels;
  },
  getNewsPostCount: (state) => {
    return state.newsPostCount;
  },
  getCalculatorsPostCount: (state) => {
    return state.calculatorsPostCount;
  },
  getNormativePostCount: (state) => {
    return state.normativePostCount;
  },
  getAdditionalPostCount: (state) => {
    return state.additionalPostCount;
  },
  getGuidesArticleText: (state) => {
    return state.guidesArticle;
  },
  getGuidesArticleLoading: (state) => {
    return state.guidesArticleLoading;
  },
};

const mutations = {
  setAsideTab: (state, payload) => {
    state.asideTab = payload;
  },
  categoryForceOpen: (state, payload) => {
    state.categoryForceOpen = payload;
  },
  setPageType: (state, payload) => {
    state.pageType = payload;
  },
  setTitleType: (state, payload) => {
    state.titleType = payload;
  },
  setTreeLoadStatus: (state, payload) => {
    state.loadingTree = payload;
  },
  setTreeData: (state, payload) => {
    state["tree_" + payload.index] = payload.data;
  },
  setFavoritesData: (state, favoritesArray) => {
      state.favorites = favoritesArray;
  },
  changeFavoritePost: (state, favoriteData) => {
    if (favoriteData.request.action === "add") {
      state.favorites.unshift(favoriteData.response);
    } else {
      state.favorites.splice(
        //todo сериализировать ответы, чтобы получать всегда единый регистр в base_id
        state.favorites.findIndex(
          (post) =>
            post.base_id.toLowerCase() ===
            favoriteData.request.base_id.toLowerCase()
        ),
        1
      );
    }
  },
  changeFavoritePostPersonalCabinet: (state, favoriteData) => {
    let existedFavorites = {};
    Object.keys(state.favoritesPersonalCabinet).forEach(key => {
      existedFavorites[key] = state.favoritesPersonalCabinet[key];
    });

    Object.keys(existedFavorites).forEach(key => {
      if (existedFavorites[key]['base_id'] === favoriteData.request.base_id) {
        delete existedFavorites[key];
      }
    });

    state.favoritesPersonalCabinet = existedFavorites;
  },
  setFavoritesLoadingData: (state, loading) => {
    state.loadingFavorites = loading;
  },
  setHistoryData: (state, historyArray) => {
    state.history = historyArray;
  },
  setContentSectionCalculatorsPostsDataFavorites: (state, data) => {
    state.contentSectionCalculatorsPostsFavorite = data;
  },
  setContentSectionNormativePostsDataFavorites: (state, data) => {
    state.contentSectionNormativePostsFavorites = data;
  },
  setContentSectionCalculatorsPostsData: (state, posts) => {
    if (Object.keys(posts).length < 19) {
      state.contentSectionCalculatorsPostsChunkFull = false;
    }
    if (!Object.keys(posts).length) {
      state.itIsAllContentSectionCalculatorsPosts = true;
    }

    let existedPosts = {};
    Object.keys(state.contentSectionCalculatorsPosts).forEach(key => {
      existedPosts[key] = state.contentSectionCalculatorsPosts[key];
    });

    if (!Object.keys(existedPosts).length && !state.itIsAllContentSectionCalculatorsPosts) {
      state.contentSectionCalculatorsPosts = posts;
    } else {
      Object.keys(posts).forEach(key => {
        let postIsset = false;

        Object.keys(existedPosts).forEach(existedKey => {
          if (posts[key]['base_id'] === existedPosts[existedKey]['base_id']) {
            postIsset = true;
          }
        });

        if (!postIsset) {
          existedPosts[Object.keys(existedPosts).length] = posts[key];
        }
      });

      state.contentSectionCalculatorsPosts = existedPosts;
    }
  },
  setContentSectionNormativePostsData: (state, posts) => {
    if (Object.keys(posts).length < 19) {
      state.contentSectionNormativePostsChunkFull = false;
    }
    if (!Object.keys(posts).length) {
      state.itIsAllContentSectionNormativePosts = true;
    }

    let existedPosts = {};
    Object.keys(state.contentSectionNormativePosts).forEach(key => {
      existedPosts[key] = state.contentSectionNormativePosts[key];
    });

    if (!Object.keys(existedPosts).length && !state.itIsAllContentSectionNormativePosts) {
      state.contentSectionNormativePosts = posts;
    } else {
      Object.keys(posts).forEach(key => {
        let postIsset = false;

        Object.keys(existedPosts).forEach(existedKey => {
          if (posts[key]['base_id'] === existedPosts[existedKey]['base_id']) {
            postIsset = true;
          }
        });

        if (!postIsset) {
          existedPosts[Object.keys(existedPosts).length] = posts[key];
        }
      });

      state.contentSectionNormativePosts = existedPosts;
    }
  },
  setContentSectionAdditionalPostsData: (state, posts) => {
    if (Object.keys(posts).length < 19) {
      state.contentSectionAdditionalPostsChunkFull = false;
    }
    if (!Object.keys(posts).length) {
      state.itIsAllContentSectionAdditionalPosts = true;
    }

    let existedPosts = {};
    Object.keys(state.contentSectionAdditionalPosts).forEach(key => {
      existedPosts[key] = state.contentSectionAdditionalPosts[key];
    });

    if (!Object.keys(existedPosts).length && !state.itIsAllContentSectionAdditionalPosts) {
      state.contentSectionAdditionalPosts = posts;
    } else {
      Object.keys(posts).forEach(key => {
        let postIsset = false;

        Object.keys(existedPosts).forEach(existedKey => {
          if (posts[key]['id'] === existedPosts[existedKey]['id']) {
            postIsset = true;
          }
        });

        if (!postIsset) {
          existedPosts[Object.keys(existedPosts).length] = posts[key];
        }
      });

      state.contentSectionAdditionalPosts = existedPosts;
    }
  },
  setHistoryDataPersonalCabinet: (state, historyArray) => {
    if (!Object.keys(historyArray).length) {
      state.itIsAllHistory = true;
    }

    let postCount = 0;
    Object.keys(historyArray).forEach(key => {
      postCount += Object.keys(historyArray[key]).length;
    });
    if (postCount < 19) {
      state.historyPersonalCabinetChunkFull = false;
    }

    let existHistory = {};
    Object.keys(state.historyPersonalCabinet).forEach(key => {
      existHistory[key] = state.historyPersonalCabinet[key];
    });

    Object.keys(historyArray).forEach(key => {
      if (existHistory[key] !== undefined) {
        let existedData = historyArray[key];
        let finalArray = {};

        Object.keys(existedData).forEach(existKey => {
          if (!(
              existHistory[key][existKey] === undefined ||
              (existedData[existKey]['base_id'] === existHistory[key][existKey]['base_id'] &&
              existedData[existKey]['created_at'] === existHistory[key][existKey]['created_at'])
              )
          ) {
            finalArray[key] = existedData[existKey];
          }
        });

        if (finalArray[key] !== undefined) {
          existHistory[key] = existHistory[key].concat(finalArray[key]);
        }
      } else {
        existHistory[key] = historyArray[key];
      }
    });

    state.historyPersonalCabinet = existHistory;
  },
  setHistoryLoadingData: (state, loading) => {
    state.loadingHistory = loading;
  },
  setLoadingContentSectionCalculatorsPosts: (state, loading) => {
    state.loadingContentSectionCalculatorsPosts = loading;
  },
  setLoadingContentSectionNormativePosts: (state, loading) => {
    state.loadingContentSectionNormativePosts = loading;
  },
  setLoadingContentSectionAdditionalPosts: (state, loading) => {
    state.loadingContentSectionAdditionalPosts = loading;
  },
  setHistoryLoadingDataPersonalCabinet: (state, loading) => {
    state.loadingHistoryPersonalCabinet = loading;
  },
  addHistoryPostMutation: (state, historyData) => {
    state.history.unshift(historyData);
  },
  setSpecialtyLoadingData: (state, loading) => {
    state.loadingSpecialty = loading;
  },
  setSpecialtyData: (state, specialtyArray) => {
    state.specialty = specialtyArray;
  },
  setUserSpecialtyData: (state, userSpecialtyArray) => {
    state.userSpecialty = userSpecialtyArray;
  },
  setNewsLoadingData: (state, loading) => {
    state.loadingNews = loading;
  },
  setNewsData: (state, newsArray) => {
    state.news = newsArray;
  },
  setNewsHasMore: (state, hasMore) => {
    state.newsHasMore = hasMore;
  },
  setPersonalCabinetMenuLabels: (state, labels) => {
    state.personalCabinetMenuLabels = labels;
  },
  setNewsPostCount: (state, count) => {
    state.newsPostCount = count;
  },
  setCalculatorsPostCount: (state, count) => {
    state.calculatorsPostCount = count;
  },
  setNormativePostCount: (state, count) => {
    state.normativePostCount = count;
  },
  setAdditionalPostCount: (state, count) => {
    state.additionalPostCount = count;
  },
  setGuidesArticle: (state, data) => {
    state.guidesArticle = data;
    state.guidesArticleLoading = false;
  },
  setGuidesArticleLoading: (state, value) => {
    state.guidesArticleLoading = value;
  },

};

const actions = {
  changeAsideTab({ commit }, payload) {
    commit("setAsideTab", payload);
  },
  // setMainTreeAsync({ commit }, payload) {
  //   commit("setTitleType", payload);
  //   commit("setTreeLoadStatus", true);
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get("get-tree/" + payload)
  //       .then((response) => {
  //         commit("setTreeData", { index: payload, data: response.data.data });
  //         commit("setPageType", payload);
  //         commit("setTreeLoadStatus", false);
  //         resolve(response);
  //       })
  //       .catch((err) => {
  //         commit("setTreeLoadStatus", false);
  //         reject(err);
  //       });
  //   });
  // },
  setMainTreeAsync({ commit }, payload) {
    //declare loading function
    async function loadingTree(tree) {
      let { data } = await axios.get("get-tree/" + tree);
      commit("setTreeData", { index: tree, data: data.data });
      commit("setPageType", tree);
      commit("setTreeLoadStatus", false);
      setTimeout(function () {
        commit("categoryForceOpen", false);
      }, 1000);
    }
    //action block
    commit("setTitleType", payload);
    commit("setTreeLoadStatus", true);
    if (state["tree_" + payload] == undefined && payload !== null) {
      loadingTree(payload);
    } else {
      commit("setPageType", payload);
      commit("setTreeLoadStatus", false);
      setTimeout(function () {
        commit("categoryForceOpen", false);
      }, 1000);
    }
  },
  async setMainTreeWithoutReloading({ commit }, payload) {
    commit("setTreeLoadStatus", true);
    let { data } = await axios.get("get-tree/" + payload);
    commit("setTreeData", { index: payload, data: data.data });
    commit("setTitleType", payload);
    commit("setTreeLoadStatus", false);
  },
  updatePageType({ commit }, payload) {
    commit("setPageType", payload);
    commit("setTitleType", payload);
  },
  setCategoryOpen({ commit }, payload) {
    commit("categoryForceOpen", payload);
  },
  resetFavorites({ commit }) {
    commit("setFavoritesData", []);
    commit("setFavoritesLoadingData", "empty");
    commit("setAsideTab", 1);
  },
  async loadFavorites({ commit }) {
    commit("setFavoritesLoadingData", true);
    let { data } = await this._vm.axios.get("account/favorites");
    commit("setFavoritesData", data.data);
    commit("setFavoritesLoadingData", false);
  },
  async loadHistory({ commit }) {
    commit("setHistoryLoadingData", true);
    let { data } = await this._vm.axios.get("account/history");
    commit("setHistoryData", data.data);
    commit("setHistoryLoadingData", false);
  },
  async loadContentSectionCalculatorsPosts({ commit }) {
    commit("setLoadingContentSectionCalculatorsPosts", true);
    let { data } = await this._vm.axios.get("account/content-sections/calculators?offset=" + state.contentSectionCalculatorsPostsOffset);
    commit("setContentSectionCalculatorsPostsData", data.data);
    commit("setCalculatorsPostCount", data.post_count);
    commit("setLoadingContentSectionCalculatorsPosts", false);
    state.contentSectionCalculatorsPostsOffset += 20;
  },
  async loadContentSectionCalculatorsPostsFavorites({ commit }) {
    commit("setLoadingContentSectionCalculatorsPosts", true);
    let { data } = await this._vm.axios.get("account/content-sections/calculators?is_favorites=true");
    commit("setContentSectionCalculatorsPostsDataFavorites", data.data);
    commit("setLoadingContentSectionCalculatorsPosts", false);
  },
  async loadContentSectionNormativePosts({ commit }) {
    commit("setLoadingContentSectionNormativePosts", true);
    let { data } = await this._vm.axios.get("account/content-sections/normative?offset=" + state.contentSectionNormativePostsOffset);
    commit("setContentSectionNormativePostsData", data.data);
    commit("setNormativePostCount", data.post_count);
    commit("setLoadingContentSectionNormativePosts", false);
    state.contentSectionNormativePostsOffset += 20;
  },
  async loadContentSectionNormativePostsFavorites({ commit }) {
    commit("setLoadingContentSectionNormativePosts", true);
    let { data } = await this._vm.axios.get("account/content-sections/normative?is_favorites=true");
    commit("setContentSectionNormativePostsDataFavorites", data.data);
    commit("setLoadingContentSectionNormativePosts", false);
  },
  async loadContentSectionAdditionalPosts({ commit }) {
    commit("setLoadingContentSectionAdditionalPosts", true);
    let { data } = await this._vm.axios.get("account/content-sections/additional?offset=" + state.contentSectionAdditionalPostsOffset);
    commit("setContentSectionAdditionalPostsData", data.data);
    commit("setAdditionalPostCount", data.post_count);
    commit("setLoadingContentSectionAdditionalPosts", false);
    state.contentSectionAdditionalPostsOffset += 20;
  },
  async loadHistoryPersonalCabinet({ commit }) {
    commit("setHistoryLoadingDataPersonalCabinet", true);
    let { data } = await this._vm.axios.get("account/history?offset=" + state.historyOffset);
    commit("setHistoryDataPersonalCabinet", data.data);
    commit("setHistoryLoadingDataPersonalCabinet", false);
    state.historyOffset += 20;
  },
  async toggleFavorite({ commit }, favoriteData) {
    let { data } = await this._vm.axios.post(
      "/account/favorite-toggle",
      favoriteData
    );
    commit("changeFavoritePost", {
      response: data.data,
      request: favoriteData,
    });
  },
  async loadSpecialty({ commit }) {
    commit("setSpecialtyLoadingData", true);
    let { data } = await this._vm.axios.get("account/specialty");
    commit("setSpecialtyData", data.data);
    commit("setSpecialtyLoadingData", false);
  },
  async loadUserSpecialty({ commit }) {
    commit("setSpecialtyLoadingData", true);
    let { data } = await this._vm.axios.get("account/news-subscribe");
    commit("setUserSpecialtyData", data.data);
    commit("setSpecialtyLoadingData", false);
  },
  async setUserSpecialty({ commit }, payload) {
    await this._vm.axios.post("account/news-subscribe", {
      specialty: payload,
    });
    commit("setUserSpecialtyData", payload);
  },
  async refreshContentSectionCalculatorsPosts({ commit }) {
    state.contentSectionCalculatorsPosts = [];
    state.contentSectionCalculatorsPostsOffset = 0;
    commit("setLoadingContentSectionCalculatorsPosts", true);
    let { data } = await this._vm.axios.get("account/content-Sections/calculators?offset=" + state.contentSectionCalculatorsPostsOffset);
    commit("setContentSectionCalculatorsPostsData", data.data);
    commit("setLoadingContentSectionCalculatorsPosts", false);
    state.contentSectionCalculatorsPostsOffset += 20;
    state.itIsAllContentSectionCalculatorsPosts = !Object.keys(data.data).length;
    state.contentSectionCalculatorsPostsChunkFull = Object.keys(data.data).length >= 19;

  },
  async loadNews({ commit }, isAllNews = false) {
    commit("setNewsHasMore", false);
    commit("setNewsData", []);
    commit("setNewsLoadingData", true);

    let { data } = await this._vm.axios.post("account/news", {
      specialty: state.userSpecialty,
      is_all_news: isAllNews,
    });

    commit("setNewsHasMore", data.hasMore);
    commit("setNewsData", data.data);
    commit("setNewsPostCount", data.post_count);
    commit("setNewsLoadingData", false);
  },
  async loadNewsMore({ commit, getters: { getNewsArray } = {} }, isAllNews = false) {
    const news = getNewsArray;
    commit("setNewsHasMore", false);
    commit("setNewsLoadingData", true);

    let { data } = await this._vm.axios.post("account/news", {
      specialty: JSON.parse(localStorage.getItem("specialty") || "[]").map(
        (item) => item.split("sp")[1]
      ),
      offset: news.length,
      is_all_news: isAllNews,
    });

    commit("setNewsHasMore", data.hasMore);
    commit("setNewsData", news.concat(data.data));
    commit("setNewsLoadingData", false);
  },
  async loadPersonalCabinetMenuLabels({ commit }) {
    let { data } = await this._vm.axios.get("account/menu-labels");
    commit("setPersonalCabinetMenuLabels", data);
  },
  async setContentSectionLastPost({ commit }, data) {
    await this._vm.axios.post("account/save-content-section-last-post", {
      type: data.type,
      last_post_id: data.lastPostId,
      post_count: data.post_count,
      is_material: data.isMaterial,
    });
  },
  async getGuidesArticle({ commit }) {
    commit("setGuidesArticleLoading", true);
    let { data } = await this._vm.axios.get("get-article-for-guides");
    commit("setGuidesArticle", data.data);
  },
  resetNewLabel: function () {
    const link = document.querySelector('li.menu-nav__item.active > a');
    if (link.classList.contains("has-new-posts")) {
      link.classList.remove("has-new-posts");
    }
  },
  async addAdditionalMaterialsLog({ commit }, data) {
    await this._vm.axios.post("account/add-additional-materials-log", {
      id: data.id,
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
